import React from "react";
import "./SkeletonStyle/SkeletonStyle.css";

export const SubscriptionSkeleton = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <div
        className="skeleton"
        style={{ width: "240px", height: "34px", marginBottom: "2rem" }}
      ></div>

      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        {Array.from({ length: 4 }).map((_, rowIndex) => (
          <div
            key={rowIndex}
            style={{
              display: "flex",
              gap: "1rem",
              width: "50%",
            }}
          >
            <div style={{ width: "50%" }}>
              <div
                className="skeleton"
                style={{ width: "120px", height: "16px", marginBottom: "10px" }}
              ></div>
              <div
                className="skeleton"
                style={{ width: "100%", height: "24px", marginBottom: "0" }}
              ></div>
            </div>
            <div style={{ width: "50%" }}>
              <div
                className="skeleton"
                style={{ width: "120px", height: "16px", marginBottom: "10px" }}
              ></div>
              <div
                className="skeleton"
                style={{ width: "100%", height: "24px", marginBottom: "0" }}
              ></div>
            </div>
          </div>
        ))}
      </div>

      <div style={{ display: "flex", gap: "1rem", marginTop: "2rem" }}>
        <div
          className="skeleton"
          style={{ width: "190px", height: "44px", marginBottom: "0" }}
        ></div>
        <div
          className="skeleton"
          style={{ width: "190px", height: "44px", marginBottom: "0" }}
        ></div>
      </div>
    </div>
  );
};
